export var getAmadeusPriceTotal = function (price, currencyMap) {
    var currency = currencyMap === null || currencyMap === void 0 ? void 0 : currencyMap[price.currencyCode];
    if (!currency) {
        return price.total;
    }
    return price.total / Math.pow(10, currency.decimalPlaces);
};
